////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div>
    <span class="login-form-title">{{i18n.login.signin}}</span>
    <Form ref="loginData" :model="loginData" :rules="loginDataRules">
        <!--Form-item prop="host">
          <Select v-model="host" placeholder="Выберите торговую сеть" icon="android-contact" size="large" class="input-left-icon" @on-change="hostOnChange">
            <Option v-for="(item, key) in appSettings.server.hosts" :value="key" :key="key">{{ key }}</Option>
          </Select>
        </Form-item-->
        <!--Form-item prop="login">
          <Input type="text" v-model="loginData.login" :placeholder="i18n.login.login" icon="android-contact" size="large" class="input-left-icon"></Input>
        </Form-item-->
        <!--Form-item prop="login">
          <Select v-model="loginData.login" :placeholder="i18n.login.login" icon="android-contact" size="large" class="input-left-icon">
            <Option v-for="item in usersListToLogin" :value="item.id" :key="item.id">{{ item.Name }}</Option>
          </Select>
        </Form-item-->
        <Form-item prop="login">
          <select v-model="loginData.login" :placeholder="i18n.login.login" icon="android-contact" size="large" class="input-left-icon"
           style="height:36px; padding: 0 0 0 8px; width: 100%; font-size: 14px;">
            <!--option :value="0" :key="0">- Выберите пользователя -</option-->
            <option v-for="item in usersListToLogin" :value="item.id" :key="item.id">{{ item.Name }}</option>
          </select>
        </Form-item>
        <Form-item prop="password">
          <Input type="password" v-model="loginData.password" :placeholder="i18n.login.password" icon="locked" size="large" class="input-left-icon"
           @on-enter="submitOnClick()"></Input>
        </Form-item>
        <Form-item>
          <Button type="primary" size="large" class="login-form-button no-circle" long @click="submitOnClick()">{{i18n.login.signin}}</Button>
          <!--Row class="login-form-links-group">
            <Col span="12" class="text-align-center"><router-link to="/welcome/signup">{{i18n.login.signup}}</router-link></Col>
            <Col span="12" class="text-align-center"><router-link to="/welcome/forgotPassword">{{i18n.login.forgotPassword}}</router-link></Col>
          </Row-->
      </Form-item>
    </Form>
  </div>
</template>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import http from 'axios'

export default {
  name: 'SignIn',
  data () {
    return {
      host: null,
      usersListToLogin: [],
      loginData: {
        login: 1,
        password: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'i18n'
    ]),
    loginDataRules: function () {
      return {
        /* login: [
          { required: true, message: this.i18n.login.validations.fieldCannotBeEmpty, trigger: 'blur' }
        ], !!!!!!!!!!!!!!!! */
        // login: [
        //  { validator: function (rule, value, callback) { /* console.log('!!! login validator inside !!!!'); */ if (value === 1) return callback(new Error('Выберите пользователя не по умолчанию' /* this.i18n.login.validations.fieldCannotBeEmpty */)); callback() }, trigger: 'blur' }
        // ],
        password: [
          { required: true, message: this.i18n.login.validations.fieldCannotBeEmpty, trigger: 'blur' }
        ]
      }
    }
  },
  created: function () {
    // let host = localStorage.getItem('BMSClientHost')
    let host = 'ФК АССОЦИАЦИЯ'
    if (host != null) {
      this.host = host
      this.hostOnChange()
    }
  },
  methods: {
    ...mapMutations([
      'appStateServerConnectedSet',
      'activeUserSet',
      'serverHostSet'
    ]),
    hostOnChange: function () {
      var thisRef = this
      let host = localStorage.getItem('BMSClientHost')
      if (this.host !== host) {
        localStorage.setItem('BMSClientHost', this.host)
        localStorage.setItem('BMSClientUser', 1)
        this.loginData.login = 1
      }
      this.serverHostSet(this.host)
      http.get(this.appSettings.server.host + this.appSettings.server.userGetUsersListToLogin)
      .then(function (response) {
        thisRef.usersListToLogin = response.data
        let userId = localStorage.getItem('BMSClientUser')
        if (userId != null) thisRef.loginData.login = userId
      })
      .catch(function (error) {
        if (error.response) {
          thisRef.$message.error('Ошибка при попытке обратиться к серверу: ' + error.response.status + ', ' + error.response.data.error)
        } else {
          thisRef.$message.error('Ошибка при попытке обратиться к серверу: Сервер не доступен')
        }
        thisRef.appStateServerConnectedSet(false)
        thisRef.$router.push('/serverisnotavailable')
      })
    },
    submitOnClick () {
      localStorage.setItem('BMSClientUser', this.loginData.login)
      this.$refs['loginData'].validate((valid) => {
        if (valid) {
          var thisRef = this
          http.post(this.appSettings.server.host + this.appSettings.server.userLogin, {id: this.loginData.login, password: this.loginData.password})
          .then(function (response) {
            // localStorage.setItem('BMSClient2017ActiveUser', JSON.stringify(response.data))
            thisRef.activeUserSet(response.data)
            thisRef.loginData.password = '' // трем перед тем как уйти со страницы welcome. тогда при возврате на нее пароль не будет доступен
            thisRef.$router.push('/')
          })
          .catch(function (error) {
            if (error.response === null) {
              thisRef.$message.error('Ошибка при попытке обратиться к серверу: Сервер не доступен')
              thisRef.appStateServerConnectedSet(false)
              thisRef.$router.push('/serverisnotavailable')
            } else {
              if (error.response.status !== 400) {
                thisRef.$message.error('Ошибка при попытке обратиться к серверу: ' + error.response.status + ', ' + JSON.stringify(error.response.data))
              } else {
                thisRef.$message.error(error.response.data)
              }
            }
          })
        } else {
          this.$message.error('Поля заполненны не верно, попробуйте еще раз')
        }
      })
    }
  }
}
</script>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
</style>

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// SignIn.vue?6f156c4c